import { Injectable } from '@angular/core';
import {
  NzNotificationService,
  NzNotificationDataOptions,
  NzNotificationPlacement,
} from 'ng-zorro-antd/notification';

type NotiType = 'success' | 'error' | 'info' | 'warning';

@Injectable({
  providedIn: 'root',
})
export class CustomNotificationService {
  private readonly iconMap: Record<NotiType, string> = {
    success: 'check-circle',
    error: 'close-circle',
    info: 'info-circle',
    warning: 'exclamation-circle',
  };

  private readonly colorMap: Record<NotiType, string> = {
    success: '#52c41a',
    error: '#ff4d4f',
    info: '#1890ff',
    warning: '#faad14',
  };

  constructor(private readonly notification: NzNotificationService) {}

  show(
    type: NotiType,
    title: string,
    description: string,
    placement: NzNotificationPlacement,
    override: NzNotificationDataOptions = { nzDuration: 3000 },
  ): void {
    this.notification.create(type, title, description, {
      nzStyle: {
        background: '#ffff',
        borderRadius: '12px',
        color: '#000',
        ...override.nzStyle,
      },
      nzClass: 'custom-notification',
      nzPlacement: placement,
      nzDuration: override.nzDuration,
    });
  }
}
